import { render, staticRenderFns } from "./EmailLabel.vue?vue&type=template&id=2d4903a6&"
import script from "./EmailLabel.vue?vue&type=script&lang=js&"
export * from "./EmailLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports